import type { Round } from '@h2h/shared';

export function isRoundInPlay(round: Round | null | undefined): boolean {
  const status = round?.status;
  return status === 'OPEN' || status === 'LOCKING' || status === 'SETTLING';
}
